import React from 'react';

//images
import Close from 'css/images/close.svg';

const AlertGracias = ({ onClose }) => {
	return (
		<div className="body-alert">
			<div className="custom-alert orange">
				<div className="alert-header">
					<div className="head-deco">
						<img src={Close} onClick={onClose} alt="Cerrar" />
					</div>
				</div>
				<div className="alert-body">
					<p>¡Enhorabuena!</p>
					<h2>¡TUS PUNTOS HAN SIDO CANJEADOS!</h2>
					<p>En breve recibirás un email con la confirmación del pedido.</p>
					<h5>¡Muchas gracias!</h5>
				</div>
			</div>
		</div>
	);
};

export default AlertGracias;
